import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaTools, FaCheck, FaCar, FaWrench, FaClock, FaExclamationTriangle } from 'react-icons/fa';

export default function Mantenimiento({ goBack }) {
    const [vehiculos, setVehiculos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { fetchVehiculos(); }, []);

    const fetchVehiculos = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/vehiculos');
            setVehiculos(res.data);
        } catch (error) {
            console.error('Error cargando vehículos:', error);
            Swal.fire('Error', 'No se pudieron cargar los vehículos', 'error');
        } finally {
            setLoading(false);
        }
    };

    const enviarTaller = async (car) => {
        const { value: formValues } = await Swal.fire({
            title: '🔧 Enviar a Mantenimiento',
            html: `
                <div class="text-start">
                    <div class="mb-3">
                        <label class="form-label fw-bold">Vehículo</label>
                        <div class="alert alert-info mb-3">
                            <strong>${car.marca} ${car.modelo}</strong> - ${car.placa}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Motivo / Descripción *</label>
                        <textarea id="descripcion" class="form-control" rows="4" placeholder="Ej: Cambio de aceite, revisión de frenos..." style="border-radius: 10px;"></textarea>
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Enviar a Taller',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#f093fb',
            cancelButtonColor: '#6c757d',
            preConfirm: () => {
                const desc = document.getElementById('descripcion').value;
                if (!desc) {
                    Swal.showValidationMessage('Por favor ingrese una descripción');
                    return false;
                }
                return { descripcion: desc };
            }
        });

        if (formValues) {
            try {
                await axios.post('https://api.alquilacarbolivia.com/api/operaciones/mantenimiento/iniciar', { 
                    vehiculo_id: car.id, 
                    descripcion: formValues.descripcion 
                });
                
                await Swal.fire({
                    icon: 'success',
                    title: '¡Enviado a Taller!',
                    text: `${car.marca} ${car.modelo} está ahora en mantenimiento`,
                    confirmButtonColor: '#f093fb'
                });
                
                fetchVehiculos();
            } catch (error) {
                Swal.fire('Error', 'No se pudo enviar a mantenimiento', 'error');
            }
        }
    };

    const finalizarTaller = async (car) => {
        const { value: formValues } = await Swal.fire({
            title: '✅ Finalizar Mantenimiento',
            html: `
                <div class="text-start">
                    <div class="mb-3">
                        <label class="form-label fw-bold">Vehículo</label>
                        <div class="alert alert-warning mb-3">
                            <strong>${car.marca} ${car.modelo}</strong> - ${car.placa}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Costo Total (Bs) *</label>
                        <input type="number" id="costo" class="form-control" step="0.01" placeholder="0.00" style="border-radius: 10px;">
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Observaciones (opcional)</label>
                        <textarea id="observaciones" class="form-control" rows="3" placeholder="Trabajos realizados, piezas cambiadas..." style="border-radius: 10px;"></textarea>
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Finalizar y Liberar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#11998e',
            cancelButtonColor: '#6c757d',
            preConfirm: () => {
                const costo = document.getElementById('costo').value;
                const obs = document.getElementById('observaciones').value;
                if (!costo || parseFloat(costo) <= 0) {
                    Swal.showValidationMessage('Por favor ingrese un costo válido');
                    return false;
                }
                return { costo: parseFloat(costo), observaciones: obs };
            }
        });

        if (formValues) {
            try {
                await axios.post('https://api.alquilacarbolivia.com/api/operaciones/mantenimiento/finalizar', { 
                    vehiculo_id: car.id, 
                    mantenimiento_id: 1,
                    costo: formValues.costo,
                    observaciones: formValues.observaciones
                });
                
                await Swal.fire({
                    icon: 'success',
                    title: '¡Mantenimiento Finalizado!',
                    text: `${car.marca} ${car.modelo} está ahora disponible`,
                    confirmButtonColor: '#11998e'
                });
                
                fetchVehiculos();
            } catch (error) {
                Swal.fire('Error', 'No se pudo finalizar el mantenimiento', 'error');
            }
        }
    };

    const getEstadoConfig = (estado) => {
        const configs = {
            'libre': { 
                gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', 
                label: 'DISPONIBLE',
                icon: '✓',
                textColor: 'white'
            },
            'ocupado': { 
                gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)', 
                label: 'EN RENTA',
                icon: '🚗',
                textColor: 'white'
            },
            'mantenimiento': { 
                gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 
                label: 'EN TALLER',
                icon: '🔧',
                textColor: 'white'
            }
        };
        return configs[estado] || configs['libre'];
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{minHeight: '100vh'}}>
                <div className="spinner-border" style={{
                    width: '3rem', 
                    height: '3rem',
                    color: '#f093fb'
                }}></div>
            </div>
        );
    }

    const vehiculosLibres = vehiculos.filter(v => v.estado === 'libre');
    const vehiculosEnTaller = vehiculos.filter(v => v.estado === 'mantenimiento');
    const vehiculosOcupados = vehiculos.filter(v => v.estado === 'ocupado');

    return (
        <div className="container-fluid p-0" style={{
            background: 'linear-gradient(to bottom, #f8f9fa 0%, #e9ecef 100%)', 
            minHeight: '100vh'
        }}>
            {/* HEADER MEJORADO */}
            <div className="shadow-lg" style={{
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                padding: '20px 30px'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <button 
                            className="btn btn-light btn-sm me-3 shadow-sm" 
                            onClick={goBack}
                            style={{borderRadius: '20px', padding: '10px 20px'}}
                        >
                            <FaArrowLeft className="me-2"/> Volver
                        </button>
                        <div className="d-flex align-items-center">
                            <div className="bg-white bg-opacity-25 p-2 rounded-circle me-3">
                                <FaTools style={{fontSize: '1.8rem', color: 'white'}}/>
                            </div>
                            <div className="text-white">
                                <h3 className="m-0 fw-bold" style={{letterSpacing: '1px'}}>CONTROL DE TALLER</h3>
                                <small style={{opacity: 0.9}}>Gestión de mantenimientos</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-4">
                {/* ESTADÍSTICAS */}
                <div className="row mb-4 g-3">
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4 d-flex align-items-center">
                                <div className="bg-white bg-opacity-25 p-3 rounded-circle me-3">
                                    <FaCheck style={{fontSize: '2rem'}}/>
                                </div>
                                <div>
                                    <h2 className="fw-bold mb-0">{vehiculosLibres.length}</h2>
                                    <div>Disponibles</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4 d-flex align-items-center">
                                <div className="bg-white bg-opacity-25 p-3 rounded-circle me-3">
                                    <FaWrench style={{fontSize: '2rem'}}/>
                                </div>
                                <div>
                                    <h2 className="fw-bold mb-0">{vehiculosEnTaller.length}</h2>
                                    <div>En Taller</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4 d-flex align-items-center">
                                <div className="bg-white bg-opacity-25 p-3 rounded-circle me-3">
                                    <FaCar style={{fontSize: '2rem'}}/>
                                </div>
                                <div>
                                    <h2 className="fw-bold mb-0">{vehiculosOcupados.length}</h2>
                                    <div>En Renta</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SECCIÓN: VEHÍCULOS EN TALLER */}
                {vehiculosEnTaller.length > 0 && (
                    <>
                        <div className="mb-3">
                            <h5 className="fw-bold" style={{color: '#2d3748'}}>
                                🔧 Vehículos en Taller ({vehiculosEnTaller.length})
                            </h5>
                        </div>
                        <div className="row g-4 mb-5">
                            {vehiculosEnTaller.map(car => {
                                const estadoConfig = getEstadoConfig(car.estado);
                                return (
                                    <div key={car.id} className="col-xl-3 col-lg-4 col-md-6">
                                        <div 
                                            className="card h-100 border-0 shadow-lg" 
                                            style={{
                                                borderRadius: '20px',
                                                overflow: 'hidden',
                                                background: 'white',
                                                border: '3px solid transparent',
                                                backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                                backgroundOrigin: 'border-box',
                                                backgroundClip: 'padding-box, border-box'
                                            }}
                                        >
                                            <div className="card-body p-4">
                                                {/* Badge de estado */}
                                                <div className="mb-3">
                                                    <span 
                                                        className="badge px-3 py-2 fw-bold"
                                                        style={{
                                                            background: estadoConfig.gradient,
                                                            color: estadoConfig.textColor,
                                                            fontSize: '0.75rem',
                                                            borderRadius: '10px',
                                                            letterSpacing: '0.5px'
                                                        }}
                                                    >
                                                        {estadoConfig.icon} {estadoConfig.label}
                                                    </span>
                                                </div>

                                                {/* Info del vehículo */}
                                                <h5 className="fw-bold mb-2" style={{color: '#2d3748'}}>
                                                    {car.marca} {car.modelo}
                                                </h5>
                                                <div className="d-flex gap-2 mb-3">
                                                    <span className="badge bg-light text-dark">📋 {car.placa}</span>
                                                    <span className="badge bg-light text-dark">📅 {car.anio}</span>
                                                </div>

                                                {/* Alerta de tiempo */}
                                                <div className="alert alert-warning border-0 mb-3 p-2 small" style={{
                                                    borderRadius: '10px',
                                                    background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                                                }}>
                                                    <FaClock className="me-2"/>
                                                    <strong>En taller desde hoy</strong>
                                                </div>

                                                {/* Botón finalizar */}
                                                <button 
                                                    className="btn w-100 fw-bold shadow-sm"
                                                    onClick={() => finalizarTaller(car)}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '15px',
                                                        padding: '12px'
                                                    }}
                                                >
                                                    <FaCheck className="me-2"/> Finalizar Reparación
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}

                {/* SECCIÓN: VEHÍCULOS DISPONIBLES */}
                <div className="mb-3">
                    <h5 className="fw-bold" style={{color: '#2d3748'}}>
                        🚗 Todos los Vehículos ({vehiculos.length})
                    </h5>
                </div>
                <div className="row g-4">
                    {vehiculos.map(car => {
                        const estadoConfig = getEstadoConfig(car.estado);
                        const necesitaMantenimiento = car.kilometraje_actual >= (car.proximo_mantenimiento_km || 5000);
                        
                        return (
                            <div key={car.id} className="col-xl-3 col-lg-4 col-md-6">
                                <div 
                                    className="card h-100 border-0 shadow-lg" 
                                    style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        transform: 'translateY(0)',
                                        transition: 'all 0.3s ease',
                                        background: 'white'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '';
                                    }}
                                >
                                    <div className="card-body p-4">
                                        {/* Badge de estado */}
                                        <div className="mb-3">
                                            <span 
                                                className="badge px-3 py-2 fw-bold"
                                                style={{
                                                    background: estadoConfig.gradient,
                                                    color: estadoConfig.textColor,
                                                    fontSize: '0.75rem',
                                                    borderRadius: '10px',
                                                    letterSpacing: '0.5px'
                                                }}
                                            >
                                                {estadoConfig.icon} {estadoConfig.label}
                                            </span>
                                        </div>

                                        {/* Info del vehículo */}
                                        <h5 className="fw-bold mb-2" style={{color: '#2d3748'}}>
                                            {car.marca} {car.modelo}
                                        </h5>
                                        <div className="d-flex gap-2 mb-3">
                                            <span className="badge bg-light text-dark">📋 {car.placa}</span>
                                            <span className="badge bg-light text-dark">📅 {car.anio}</span>
                                        </div>

                                        {/* Alerta de mantenimiento necesario */}
                                        {necesitaMantenimiento && car.estado === 'libre' && (
                                            <div className="alert alert-warning border-0 mb-3 p-2 small" style={{
                                                borderRadius: '10px',
                                                background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                                            }}>
                                                <FaExclamationTriangle className="me-2"/>
                                                <strong>Revisión recomendada</strong>
                                            </div>
                                        )}

                                        {/* Botones según estado */}
                                        {car.estado !== 'mantenimiento' && car.estado !== 'ocupado' && (
                                            <button 
                                                className="btn w-100 fw-bold shadow-sm"
                                                onClick={() => enviarTaller(car)}
                                                style={{
                                                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '15px',
                                                    padding: '12px'
                                                }}
                                            >
                                                <FaTools className="me-2"/> Enviar a Taller
                                            </button>
                                        )}

                                        {car.estado === 'ocupado' && (
                                            <div className="alert alert-danger border-0 p-2 text-center mb-0" style={{
                                                borderRadius: '10px',
                                                background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                                color: 'white'
                                            }}>
                                                <strong>🚗 Vehículo Alquilado</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
                * {
                    font-family: 'Poppins', sans-serif;
                }
            `}</style>
        </div>
    );
}